import { render, staticRenderFns } from "./WishView.vue?vue&type=template&id=40c971e1"
import script from "./WishView.vue?vue&type=script&lang=js"
export * from "./WishView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports